import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const api = axios.create({
  baseURL: `${API_URL}/`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 && error.config?.url !== '/auth/login') {
      window.dispatchEvent(new Event('auth:unauthorized'));
    }

    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  logout: () => api.post('/auth/logout'),
  getCurrentUser: () => api.get('/auth/me')
};

// Teacher API
export const teacherAPI = {
  getStudents: () => api.get('/teacher/students'),
  createStudent: (data) => api.post('/teacher/students', data),
  getGroups: () => api.get('/teacher/groups'),
  createGroup: (name) => api.post('/teacher/groups', { name }),
  moveStudentToGroup: (studentId, groupId) => 
    api.put(`/teacher/students/${studentId}/group`, { groupId }),
  
  getExerciseAccess: () => api.get('/teacher/exercise-access'),
  openExerciseForGroup: (groupId, exerciseId) => 
    api.post('/teacher/exercise-access/group', { groupId, exerciseId }),
  openExerciseForStudent: (studentId, exerciseId) => 
    api.post('/teacher/exercise-access/student', { studentId, exerciseId }),
  revokeExerciseAccess: (studentId, exerciseId) => 
    api.delete(`/teacher/exercise-access/${studentId}/${exerciseId}`),
  closeExerciseForAll: (exerciseId) =>
    api.delete(`/teacher/exercise-access/all/${exerciseId}`),
  
  getDashboard: () => api.get('/teacher/dashboard'),
  getStudentProgress: (studentId) => api.get(`/teacher/students/${studentId}/progress`)
};

// Student API
export const studentAPI = {
  getExercises: () => api.get('/student/exercises'),
  getExercise: (exerciseId) => api.get(`/student/exercises/${exerciseId}`),
  
  getWorkspace: (exerciseId, taskId) => 
    api.get(`/student/exercises/${exerciseId}/tasks/${taskId}/workspace`),
  saveWorkspace: (exerciseId, taskId, files) => 
    api.put(`/student/exercises/${exerciseId}/tasks/${taskId}/workspace`, { files }),
  runTests: (exerciseId, taskId) => 
    api.post(`/student/exercises/${exerciseId}/tasks/${taskId}/test`),
  
  getQuizStatus: (exerciseId) => 
    api.get(`/student/exercises/${exerciseId}/quiz/status`),
  startQuiz: (exerciseId) => 
    api.post(`/student/exercises/${exerciseId}/quiz/start`),
  getQuizAttempt: (attemptId) => 
    api.get(`/student/quiz-attempts/${attemptId}`),
  saveQuizAnswers: (attemptId, answers) => 
    api.patch(`/student/quiz-attempts/${attemptId}`, { answers }),
  submitQuiz: (attemptId) => 
    api.post(`/student/quiz-attempts/${attemptId}/submit`)
};

export default api;
